/*
  What the palette remembers per user in this browser: records opened from it and recent searches. A convenience only:
  storage can be unavailable (private window, blocked site data), so every access is guarded and failures are ignored.
*/
const MAX_RECORDS = 8;
const MAX_QUERIES = 5;

const recordsKey = (userId) => `cmdk.recent.v1.${userId || 'anonymous'}`;
const queriesKey = (userId) => `cmdk.queries.v1.${userId || 'anonymous'}`;

function read(key) {
  try {
    const value = JSON.parse(window.localStorage.getItem(key));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

function write(key, list) {
  try {
    window.localStorage.setItem(key, JSON.stringify(list));
  } catch {
    // ignore: storage full or blocked
  }
}

export const loadRecentRecords = (userId) => read(recordsKey(userId)).filter((entry) => entry && typeof entry.url === 'string' && entry.url.startsWith('/') && entry.title);

export function rememberRecord(userId, item) {
  if (!item?.url || !item.url.startsWith('/')) return;
  const entry = { type: item.type, id: item.id, url: item.url, title: item.title, subtitle: item.subtitle || null, number: item.number || null, at: Date.now() };
  write(recordsKey(userId), [entry, ...loadRecentRecords(userId).filter((existing) => existing.url !== entry.url)].slice(0, MAX_RECORDS));
}

export function forgetRecord(userId, url) {
  write(
    recordsKey(userId),
    loadRecentRecords(userId).filter((entry) => entry.url !== url)
  );
}

export const loadRecentQueries = (userId) => read(queriesKey(userId)).filter((query) => typeof query === 'string' && query.trim());

export function rememberQuery(userId, query) {
  const text = String(query || '').trim();
  if (text.length < 2) return;
  write(queriesKey(userId), [text, ...loadRecentQueries(userId).filter((existing) => existing.toLowerCase() !== text.toLowerCase())].slice(0, MAX_QUERIES));
}
